import { createSelector } from 'reselect';

import { selectLatestActiveVersionId } from '@iconik-io/shared-lib/src/redux/entities/selectors/versions';

import type { AppState } from '../../store/types';

const getAssetId = (_state: AppState, assetId: string) => assetId;

const getAssetReviewRequests = (state: AppState) =>
  state.assetReviewApprovalsReducer.assetReviewRequests;

export const selectCurrentAssetReviewRequest = createSelector(
  [getAssetId, selectLatestActiveVersionId, getAssetReviewRequests],
  (assetId, versionId, reviewRequests) => {
    const key = `${assetId}_${versionId}`;
    return reviewRequests[key];
  },
);
